export default __webpack_public_path__ + "static/media/dmrc.fe439cfe.gif";